import VueGtag from "vue-gtag-next";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueGtag, {
    isEnabled: false,
  });
});
// id: 'G-9JPNLXTV1C'
// property: [ 'G-9JPNLXTV1C' ]getGAIds(),
